module.exports = __webpack_public_path__ + "img/pilosangeles_thumbnail.6ec0fd8c.png";